import { serviceName } from '../resources/serviceConstants';
import {
  CERTIFICATION_MAP_LIST,
  ADD_EDIT_CERTIFICATION_MAP,
  DELETE_CERTIFICATION_MAP,
} from '../resources/endPoint';

export const certificationMapList = (
  vertical,
  quarter,
  certification,
  year,
  userId,
) => {
  // API call to fetch role list
  let url = CERTIFICATION_MAP_LIST;
  const token = localStorage.getItem('userRolesToken');
  const queryParams = [];
  if (certification) {
    queryParams.push(`certification=${encodeURIComponent(certification)}`);
  }

  if (userId) {
    queryParams.push(`userId=${userId}`);
  }

  if (year) {
    queryParams.push(`year=${year}`);
  }

  if (quarter) {
    queryParams.push(`quarter=${quarter}`);
  }

  if (vertical) {
    queryParams.push(`vertical=${encodeURIComponent(vertical)}`);
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const deleteCertificationMap = (mapId) => {
  const url = DELETE_CERTIFICATION_MAP.replace('{mapId}', mapId);

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const addCertificationMapData = (data) => {
  const payload = {
    user_name: data.employeeName,
    certification_id: data.certificationID,
    user_email: data.employeeEmail,
    user_id: data.employeeID,
    employee_status: data.employeeStatus,
    vertical: data.vertical,
    achieved_date: data.certificationAchievedDate,
    expired_date: data.certificationExpiryDate,
    last_updated_by: data.lastUpdatedBy,
  };
  return {
    url: ADD_EDIT_CERTIFICATION_MAP,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: payload,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const editCertificationMapData = (data) => {
  const payload = {
    id: data.id,
    user_name: data.employeeName,
    certification_id: data.certificationID,
    user_email: data.employeeEmail,
    user_id: data.employeeID,
    employee_status: data.employeeStatus === 'Active' || data.employeeStatus === 1 ? 1 : 0,
    vertical: data.vertical,
    achieved_date: data.certificationAchievedDate,
    expired_date: data.certificationExpiryDate,
    last_updated_by: data.lastUpdatedBy,
  };

  return {
    url: ADD_EDIT_CERTIFICATION_MAP,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: payload,
    service: serviceName.CERTIFICATIONS_MS,
  };
};
